import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';
import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/angular-ivy';

if (environment.production) {
  enableProdMode();
}

if (!isDevMode()) {
  const env = environment.production ? 'production' : environment.IS_DEVELOPMENT ? 'development' : 'homologation';

  Sentry.init({
    dsn: 'https://56cca8c663dcbd95255d828f854a7b5e@o4509367585144832.ingest.us.sentry.io/4509367828873216',
    sendDefaultPii: true,
    // integrations: [Sentry.replayIntegration()],
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ['Unauthorized', 'NotAllowedError', 'ExpressionChangedAfterItHasBeenCheckedError', 'play()'],
    environment: env,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((ref) => {
    if ((window as any)['ngRef']) {
      (window as any)['ngRef'].destroy();
    }
    (window as any)['ngRef'] = ref;
  })
  .catch((err) => console.error(err));
